// src/data/selfInkData.js
import selfInk from "../assets/selfstamp/selfink1.jpg";
import selfInk1 from "../assets/selfstamp/IMG-20250827-WA0002.jpg"; 
import selfInk2 from "../assets/selfstamp/IMG-20250827-WA0003.jpg";
import selfInk3 from "../assets/selfstamp/IMG-20250827-WA0004.jpg";
import selfInk4 from "../assets/selfstamp/IMG-20250827-WA0005.jpg";
import selfInk5 from "../assets/selfstamp/IMG-20250827-WA0006.jpg";
import selfInk6 from "../assets/selfstamp/IMG-20250827-WA0007.jpg";
import selfInk7 from "../assets/selfstamp/IMG-20250827-WA0008.jpg";
import selfInk8 from "../assets/selfstamp/IMG-20250827-WA0009.jpg";
import selfInk9 from "../assets/selfstamp/IMG-20250827-WA0010.jpg";
import selfInk10 from "../assets/selfstamp/IMG-20250827-WA0011.jpg";
import selfInk11 from "../assets/selfstamp/IMG-20250827-WA0012.jpg";  


const selfInkData = [
  {
    id: 1,
    name: "Automatic Square Stamp",
    category: "Automatic",
    image: selfInk,
    size: "10x10 mm",
    description: "Compact automatic square stamp ideal for initials, small logos, or quality marks.",
  },
  {
    id: 2,
    name: "Automatic Rectangular Stamp",
    category: "Automatic",
    image: selfInk1,
    size: "33x56 mm",
    description: "Durable rectangular stamp designed for longer text, business names, or addresses.",
  },
  {
    id: 3,
    name: "Automatic Square Stamp (Large)",
    category: "Automatic",
    image: selfInk2,
    size: "40x40 mm",
    description: "Perfect for medium-sized logos, seals, or certifications with sharp impressions.",
  },
  {
    id: 4,
    name: "Automatic Round Stamp",
    category: "Automatic",
    image: selfInk3,
    size: "40x40 mm",
    description: "Round stamp commonly used for company seals, notaries, and official documents.",
  },
  {
    id: 5,
    name: "Automatic Small Rectangular Stamp",
    category: "Automatic",
    image: selfInk4,
    size: "35x12 mm",
    description: "Best for short labels, initials, or reference codes with clean impressions.",
  },
  {
    id: 6,
    name: "Automatic Medium Rectangular Stamp",
    category: "Automatic",
    image: selfInk5,
    size: "45x16 mm",
    description: "Popular size for business names, signatures, or small address details.",
  },
  {
    id: 7,
    name: "Automatic Large Rectangular Stamp",
    category: "Automatic",
    image: selfInk6,
    size: "82x22 mm",
    description: "Wide rectangular stamp ideal for address stamps, certifications, and long text.",
  },
  {
    id: 8,
    name: "Automatic Rectangular",
    category: "Automatic",
    image: selfInk7,
    size: "70x10 mm",
    description: "Sequential numbering stamp for invoices, forms, and document tracking.",
  },
  {
    id: 9,
    name: "Automatic Square",
    category: "Automatic",
    image: selfInk8,
    size: "30x30 mm",
    description: "Creates a raised, professional impression on certificates, seals, and branding.",
  },
  {
    id: 10,
    name: "Automatic Rectangular",
    category: "Automatic",
    image: selfInk9,
    size: "30x50 mm",
    description: "Custom signature stamp for quick, consistent signing of documents.",
  },
  {
    id: 11,
    name: "Automatic Rectangular",
    category: "Automatic",
    image: selfInk10,
    size: "30x50 mm",
    description: "Perfect for stamping company address details on envelopes, letters, and packaging.",
  },
  {
    id: 12,
    name: "Automatic Square",
    category: "Automatic",
    image: selfInk11,
    size: "20x20 mm",
    description: "Ideal for branding with company logos on documents, packaging, and promotional materials.",
  },

];

export default selfInkData;
